export const TERMSUPDATA = 'TERMS_UPDATA';
export const INVITEP = 'INVITEP';
export const GETMONEY = 'GETMONEY';
export const FLEETDRIVERINFO= 'FLEETDRIVERINFO'
export const FLEETPAGE = 'FLEETPAGE'
export const FLEETINFO = 'FLEETINFO'
export const REWARDAMOUNT = 'REWARDAMOUNT'
export const FLEETINVITE = 'FLEETINVITE'
export const FLEETACT = 'FLEETACT'
export const FLEETACTHISTORY = 'FLEETACTHISTORY'
export const LOGINCITY = 'LOGINCITY'